import {
  getCorporation,
  updateCorporation,
} from "../../../../../../api/configuration";
import { useSavedForm, SaveFooter, LoadState } from "./savedForm";
import {
  addressFields,
  addressSummary,
  storePayload,
  storeRecord,
  sameStore,
} from "./storeModel";
const read = async () => {
  const response = await getCorporation();
  if (response?.error !== false) throw new Error();
  return storeRecord(response.data?.corporation);
};
const write = (draft, raw) => updateCorporation(storePayload(draft, raw));
export const ShopInformation = () => {
  const form = useSavedForm(read, write, sameStore);
  if (!form.record) return <LoadState form={form} label="datos del negocio" />;
  const { draft, setDraft } = form;
  const change = (key, value) =>
    setDraft((previous) => ({ ...previous, [key]: value }));
  const changeAddress = (kind, key, value) =>
    setDraft((previous) => ({
      ...previous,
      [kind]: { ...previous[kind], [key]: value },
    }));
  const fields = (kind) => (
    <div className="row adminAddressGrid">
      {addressFields.map(([key, label, id]) => (
        <label key={key} htmlFor={kind === "shipping" ? id : `${id}2`}>
          {label}
          <input
            id={kind === "shipping" ? id : `${id}2`}
            value={draft[kind][key]}
            onChange={(e) => changeAddress(kind, key, e.target.value)}
          />
        </label>
      ))}
    </div>
  );
  return (
    <form
      className="generalReferenceForm shopInformationReference"
      onSubmit={form.save}
      aria-busy={form.saving}
    >
      <fieldset disabled={form.saving}>
        <legend className="visually-hidden">Información de la tienda</legend>
        <div className="generalFormBody">
          <h3 className="shopSectionTitle">Datos principales</h3>
          <div className="row shopMainFields">
            {[
              ["name", "Nombre de la tienda", "shopNameInput"],
              ["legalName", "Razón social", "socialReasonInput"],
              ["nif", "CIF/NIF", "CIFNIFInput"],
            ].map(([key, label, id]) => (
              <label key={key} htmlFor={id}>
                <span>
                  {label}
                  {key === "name" && <span className="requiredMark"> *</span>}
                </span>
                <input
                  id={id}
                  required={key === "name"}
                  value={draft[key]}
                  onChange={(e) => change(key, e.target.value)}
                />
              </label>
            ))}
          </div>
          <h3 className="adminAddressTitle">Dirección física</h3>
          {fields("shipping")}
          <h3 className="adminAddressTitle">Contacto</h3>
          <div className="row shopContactFields">
            {[
              ["email", "Correo electrónico", "mailInput"],
              ["phone", "Teléfono de contacto", "phoneInput"],
            ].map(([key, label, id]) => (
              <label key={key} htmlFor={id}>
                {label}
                <input
                  id={id}
                  type={key === "email" ? "email" : "tel"}
                  value={draft[key]}
                  onChange={(e) => change(key, e.target.value)}
                />
              </label>
            ))}
          </div>
          <h3 className="adminAddressTitle">Dirección fiscal</h3>
          <label className="generalCheckbox">
            <input
              type="checkbox"
              checked={draft.same}
              onChange={(e) => {
                const same = e.target.checked;
                setDraft((previous) => ({
                  ...previous,
                  same,
                  billing: same ? previous.shipping : previous.billing,
                }));
              }}
            />{" "}
            <span>
              Utilizar la misma dirección física
              {draft.same && (
                <small>
                  La dirección fiscal del negocio es la misma que la de la
                  tienda.
                </small>
              )}
            </span>
          </label>
          {draft.same ? (
            <p className="addressSummary">
              Se utiliza la dirección física:{" "}
              {addressSummary(draft.shipping) || "Sin dirección definida"}
            </p>
          ) : (
            fields("billing")
          )}
        </div>
        <SaveFooter {...form} />
      </fieldset>
    </form>
  );
};
